import styled from "styled-components";

export const Container = styled.div``;

export const Title = styled.h1`
  font-size: 20px;
  padding: 10px;
  color: #111;
`;

export const FormContainer = styled.div`
  padding: 10px;
`;

export const Label = styled.p`
  font-weight: 600;
  font-size: 16px;
  margin: 5px 5px;
`;

export const TableContainer = styled.div`
  padding: 10px;
`;

export const Divider = styled.div`
  margin: 5px 5px;

    & .subTitle {
        font-size: 18px;
        font-weight: bold;
        font-family: 'Lato', sans-serif;
    }

    & div{
        font-size: 16px;
        font-family: 'Lato', sans-serif;
    }

`;